export class BillingAdress {
  name: String;
  firma: String;
  street: String;
  plz: String;
  town: String;
  country: String;
}
